const featureModal = document.querySelector('.js-feature-modal');

if (featureModal) {
  const overlay = featureModal.querySelector('.js-feature-modal-overlay');
  const closeButton = featureModal.querySelector('.js-feature-modal-close');
  const image = featureModal.querySelector('.js-feature-modal-image');
  const imageUrl = featureModal.dataset.imageSrc;
  const { linkUrl } = featureModal.dataset;
  let closeTimer;

  const closeModal = () => {
    featureModal.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      document.body.classList.remove('feature-modal-open');
    }, 300);
  };

  const openModal = () => {
    image.src = imageUrl;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('feature-modal-open');
    window.requestAnimationFrame(() =>
      featureModal.classList.add('is-visible'),
    );
    closeButton.focus();
  };

  const openLink = () => {
    if (linkUrl) {
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    }
  };

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      closeModal();
    }
  });

  closeButton.addEventListener('click', closeModal);
  image.addEventListener('click', openLink);
  image.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openLink();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      featureModal.classList.contains('is-visible')
    ) {
      closeModal();
    }
  });

  window.setTimeout(openModal, 2000);
}
